import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { A2uiErrorBoundary } from '@/a2ui/A2uiErrorBoundary';
import { A2uiRenderer } from '@/a2ui/A2uiRenderer';
import { handleError } from '@/utils/errorUtils';

import { ArtifactCard } from '../artifact/ArtifactCard';
import { readChartTitle, validateChartTree } from './catalogValidation';
import { chartCatalog } from './chartCatalog';

export interface ChartArtifactProps {
  messages: unknown[];
}

export const ChartArtifact = ({ messages }: ChartArtifactProps) => {
  const { t } = useTranslation('common');

  const validated = useMemo(() => {
    const result = validateChartTree(messages);
    if (!result.ok) {
      handleError(
        new Error('Agent chart tree failed catalog validation'),
        { extra: { errors: result.errors } },
        'agent-chart-validation'
      );

      return null;
    }

    return result.messages;
  }, [messages]);

  if (validated === null) {
    return null;
  }

  return (
    <ArtifactCard
      kind={'chart'}
      title={readChartTitle(validated) ?? t('chat.chart.fallbackTitle')}
    >
      <A2uiErrorBoundary
        message={t('chat.chart.renderError')}
        surface={'agent-chart-render'}
      >
        <A2uiRenderer messages={validated} catalog={chartCatalog} />
      </A2uiErrorBoundary>
    </ArtifactCard>
  );
};
